module.exports = __webpack_public_path__ + "static/media/me.03a90f15.png";